/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "DeviceDiagnostics": {
                "fields": {
                  "memory": {
                    "type": ".squareup.connect.v2.DeviceDiagnostics.Memory",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cpu": {
                    "type": ".squareup.connect.v2.DeviceDiagnostics.Cpu",
                    "id": 2,
                    "rule": "optional"
                  },
                  "disk": {
                    "type": ".squareup.connect.v2.DeviceDiagnostics.Disk",
                    "id": 3,
                    "rule": "optional"
                  },
                  "network": {
                    "type": ".squareup.connect.v2.DeviceDiagnostics.Network",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Memory": {
                    "fields": {
                      "total": {
                        "type": "uint64",
                        "id": 1,
                        "rule": "optional"
                      },
                      "inUse": {
                        "type": "uint64",
                        "id": 2,
                        "rule": "optional"
                      },
                      "appLimit": {
                        "type": "uint64",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "Cpu": {
                    "fields": {
                      "isThrottled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "loadAverage1Min": {
                        "type": "double",
                        "id": 2,
                        "rule": "optional"
                      },
                      "loadAverage5Min": {
                        "type": "double",
                        "id": 3,
                        "rule": "optional"
                      },
                      "loadAverage15Min": {
                        "type": "double",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "Disk": {
                    "fields": {
                      "total": {
                        "type": "uint64",
                        "id": 1,
                        "rule": "optional"
                      },
                      "inUse": {
                        "type": "uint64",
                        "id": 2,
                        "rule": "optional"
                      },
                      "appInUse": {
                        "type": "uint64",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "Network": {
                    "fields": {
                      "bandwidth": {
                        "type": ".squareup.connect.v2.DeviceDiagnostics.Network.Bandwidth",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Bandwidth": {
                        "fields": {
                          "totalUploaded": {
                            "type": "uint64",
                            "id": 1,
                            "rule": "optional"
                          },
                          "totalDownloaded": {
                            "type": "uint64",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceDiagnostics && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceDiagnostics?.nested?.Memory && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceDiagnostics?.nested?.Cpu && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceDiagnostics?.nested?.Disk && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceDiagnostics?.nested?.Network && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceDiagnostics?.nested?.Network?.nested?.Bandwidth) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeviceDiagnostics @ squareup/devices/external/device_diagnostics.proto at 9:1
 */
export const DeviceDiagnostics = $root.lookupType('squareup.connect.v2.DeviceDiagnostics');
fixType(DeviceDiagnostics);
Builder.createAndAttachToType(DeviceDiagnostics);
/**
 * last used: 4
 *
 * SOURCE Memory @ squareup/devices/external/device_diagnostics.proto at 20:3
 */
DeviceDiagnostics.Memory = $root.lookupType('squareup.connect.v2.DeviceDiagnostics.Memory');
fixType(DeviceDiagnostics.Memory);
Builder.createAndAttachToType(DeviceDiagnostics.Memory);
/**
 * SOURCE Cpu @ squareup/devices/external/device_diagnostics.proto at 26:3
 */
DeviceDiagnostics.Cpu = $root.lookupType('squareup.connect.v2.DeviceDiagnostics.Cpu');
fixType(DeviceDiagnostics.Cpu);
Builder.createAndAttachToType(DeviceDiagnostics.Cpu);
/**
 * SOURCE Disk @ squareup/devices/external/device_diagnostics.proto at 33:3
 */
DeviceDiagnostics.Disk = $root.lookupType('squareup.connect.v2.DeviceDiagnostics.Disk');
fixType(DeviceDiagnostics.Disk);
Builder.createAndAttachToType(DeviceDiagnostics.Disk);
/**
 * SOURCE Network @ squareup/devices/external/device_diagnostics.proto at 39:3
 */
DeviceDiagnostics.Network = $root.lookupType('squareup.connect.v2.DeviceDiagnostics.Network');
fixType(DeviceDiagnostics.Network);
Builder.createAndAttachToType(DeviceDiagnostics.Network);
/**
 * SOURCE Bandwidth @ squareup/devices/external/device_diagnostics.proto at 42:5
 */
DeviceDiagnostics.Network.Bandwidth = $root.lookupType('squareup.connect.v2.DeviceDiagnostics.Network.Bandwidth');
fixType(DeviceDiagnostics.Network.Bandwidth);
Builder.createAndAttachToType(DeviceDiagnostics.Network.Bandwidth);